var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlankProgram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.7064 22.2271L34.4589 31.4746L32.5419 25.7258C32.2107 24.73 31.6518 23.8251 30.9097 23.083C30.1676 22.3409 29.2627 21.782 28.2669 21.4508L22.5181 19.5338L31.7656 10.2863",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4587 31.4747L15.0682 38.9312L22.5247 19.5407",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6875 27C1.6875 33.7133 4.35434 40.1516 9.10136 44.8986C13.8484 49.6457 20.2867 52.3125 27 52.3125C33.7133 52.3125 40.1516 49.6457 44.8986 44.8986C49.6457 40.1516 52.3125 33.7133 52.3125 27C52.3125 20.2867 49.6457 13.8484 44.8986 9.10136C40.1516 4.35434 33.7133 1.6875 27 1.6875C20.2867 1.6875 13.8484 4.35434 9.10136 9.10136C4.35434 13.8484 1.6875 20.2867 1.6875 27V27Z",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9105 23.0898L40.1265 13.8737",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankProgram);
export default __webpack_public_path__ + "static/media/BlankProgram.eb79cb609f67ffbca94f7f84ce527ebf.svg";
export { ForwardRef as ReactComponent };